import React from "react";
import { Modal, ModalProps } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInfoCircle,
  faRightFromBracket,
  faClock,
} from "@fortawesome/free-solid-svg-icons";

interface UnsavedChangesModalProps extends Omit<ModalProps, "onHide"> {
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  message?: string;
  leaveButtonText?: string;
  leaveButtonSubtext?: string;
  stayButtonText?: string;
  stayButtonSubtext?: string;
  noteText?: string;
}

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  show,
  onConfirm,
  onCancel,
  title = "Alterações não salvas",
  message = "Você tem alterações não salvas no formulário. Deseja sair sem salvar suas alterações?",
  leaveButtonText = "Sair sem salvar",
  leaveButtonSubtext = "Perderá todas as alterações",
  stayButtonText = "Continuar editando",
  stayButtonSubtext = "Voltar ao formulário",
  noteText = "Nota: Ao sair sem salvar, todas as alterações serão descartadas.",
  ...rest
}) => {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered
      className="fade"
      size="lg"
      {...rest}
    >
      <Modal.Header className="border-0 pb-0">
        <div className="d-flex justify-content-center w-100">
          <div className="rounded-circle bg-warning bg-opacity-10 p-3 mb-3">
            <FontAwesomeIcon
              icon={faInfoCircle}
              className="text-warning fa-2x"
            />
          </div>
        </div>
      </Modal.Header>
      <Modal.Body className="text-center px-4 pt-0">
        <h4 className="mb-3">{title}</h4>
        <p className="mb-4">{message}</p>
        <div className="d-flex justify-content-center mb-4">
          <div
            className="border rounded p-3 mx-2 text-center"
            style={{ width: "45%", cursor: "pointer" }}
            onClick={onConfirm}
          >
            <div
              className="rounded-circle bg-warning bg-opacity-10 p-2 mx-auto mb-2"
              style={{
                width: "48px",
                height: "48px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <FontAwesomeIcon
                icon={faRightFromBracket}
                className="text-warning fa-lg"
              />
            </div>
            <h6 className="mb-1">{leaveButtonText}</h6>
            <small className="text-muted">{leaveButtonSubtext}</small>
          </div>
          <div
            className="border rounded p-3 mx-2 text-center"
            style={{ width: "45%", cursor: "pointer" }}
            onClick={onCancel}
          >
            <div
              className="rounded-circle bg-secondary bg-opacity-10 p-2 mx-auto mb-2"
              style={{
                width: "48px",
                height: "48px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <FontAwesomeIcon icon={faClock} className="fa-lg" />
            </div>
            <h6 className="mb-1">{stayButtonText}</h6>
            <small className="text-muted">{stayButtonSubtext}</small>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0 d-flex justify-content-center">
        <small className="text-muted text-center">{noteText}</small>
      </Modal.Footer>
    </Modal>
  );
};

export default UnsavedChangesModal;
